import router from '@/router/';
import store from '@/store';

/**
 * Redirect to url
 *
 * @param  {string} url URL to redirect to.
 * @returns {void}
 */
const redirect = (url = '/') => {
    router.push(url).catch(() => {});
};

/**
 * Redirect after login.
 *
 * @returns {void}
 */
const loginRedirect = () => {
    redirect(store.state.loginRedirectUrl);
};

export default redirect;
export {
    redirect,
    loginRedirect,
};
